import { showToast } from 'BreetHelpers';
import { clearCredentials, logUserIn, selectLastVisited, useAppDispatch, useAppSelector } from 'BreetRedux';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';

export const useLoginSuccess = () => {
	const navigate = useNavigate();

	const dispatch = useAppDispatch();

	const lastVisited = useAppSelector(selectLastVisited);

	const onLoginSuccess = useCallback(() => {
		dispatch(clearCredentials());
		dispatch(logUserIn());
		navigate(lastVisited ?? '/home')?.catch(console.error);
		showToast('success', 'Login successful. Welcome back! 🎉');
	}, [dispatch, lastVisited, navigate]);

	return {
		onLoginSuccess,
	};
};
